import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ActualizarPlan = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ActualizarPlan",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ActualizarPlan };
